/**
 * 日期时间格式化过滤器
 * @param {Number|String} time - Unix时间戳（秒）或日期字符串
 * @param {String} pattern - 格式化模板，默认 '{y}-{m}-{d} {h}:{i}:{s}'
 */
export function parseTime(time, pattern = '{y}-{m}-{d} {h}:{i}:{s}') {
  if (!time) return ''

  // 如果是数字，认为是Unix时间戳
  let date
  if (typeof time === 'number') {
    // 如果是秒级时间戳，转为毫秒
    if (time < 10000000000) {
      date = new Date(time * 1000)
    } else {
      date = new Date(time)
    }
  } else {
    date = new Date(time)
  }

  if (isNaN(date.getTime())) return ''

  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds()
  }

  return pattern.replace(/{([ymdhis])+}/g, (result, key) => {
    const value = formatObj[key]
    return value.toString().padStart(2, '0')
  })
}
